/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, PageGridContainer, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/front-page';

type Props = {
  disclaimer?: string | null;
};

const styles = {
  disclaimers: css`
    padding: var(--cds-spacing-200);
    padding-top: var(--cds-spacing-400);
    margin-bottom: var(--cds-spacing-400);
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    white-space: pre-wrap;
  `,
};

const DisclaimerLOHP = ({ disclaimer }: Props) => {
  if (!disclaimer) return null;

  const disclaimerLines: Array<string> = disclaimer.split(/\*+\s/).filter(Boolean);

  disclaimerLines.forEach((line, index) => {
    if (line.includes(_t('Median salary'))) {
      disclaimerLines[index] += _t(
        'Median salary (median with 0-2 years experience for UX Designer) and job opening data are sourced from United States Lightcast™ Job Postings Report. Data for job roles relevant to featured programs (7/1/2022 - 6/30/2023)'
      );
    }
  });

  return (
    <PageGridContainer component="section" className="rc-DisclaimerLOHP">
      <Grid container>
        <Grid item xs={12} css={styles.disclaimers}>
          {disclaimerLines.map((line, index) => (
            <Typography2 key={index} component="p" variant="bodySecondary" color="supportText">
              {_t(`#{index} #{line}`, { index: '*'.repeat(index + 1), line })}
            </Typography2>
          ))}
        </Grid>
      </Grid>
    </PageGridContainer>
  );
};

export default DisclaimerLOHP;
